import { render, staticRenderFns } from "./GroupCategoryProductTypeList.vue?vue&type=template&id=6c873b0d&scoped=true"
import script from "./GroupCategoryProductTypeList.vue?vue&type=script&lang=js"
export * from "./GroupCategoryProductTypeList.vue?vue&type=script&lang=js"
import style0 from "./GroupCategoryProductTypeList.vue?vue&type=style&index=0&id=6c873b0d&prod&lang=scss"
import style1 from "./GroupCategoryProductTypeList.vue?vue&type=style&index=1&id=6c873b0d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c873b0d",
  null
  
)

export default component.exports